// extracted by mini-css-extract-plugin
export var slickWrapper = "slider-module--slick-wrapper--rVAMT";